import SGLink from '../shopgate-link';
import DebugConsole from '../debug/debug-console';

const debugConsole = new DebugConsole();
const $ = window.$;
/**
 *
 * @param {HtmlElement} container container which contains widget
 * @return {jQuery} jquery elements extended by .dropDownNavigation property (this)
 */
function dropDownNavigationInit(container) {
  const $container = $(container);
  const categories = $container.data('categories');
  const $selects = $container.find('.dropdown-navigation-level');
  const $CTAButton = $container.find('.dropdown-navigation-cta');
  const categoriesFlat = {};

  const levels = {};
  let levelsLength = 0;

  /**
   * Checks levels and hide them if there is no way it can be selected.
   *
   * @param {number} fromLevel - level from which evaluation starts
   * @param {number|undefined} selectedCategoryId - already selected category in current level
   */
  function hideNonSelectable(fromLevel, selectedCategoryId) {
    let hideFrom = false;
    const possibleIds = {};
    possibleIds[fromLevel] = [];
    if (selectedCategoryId) {
      possibleIds[fromLevel].push(selectedCategoryId);
    } else {
      levels[fromLevel].$element
        .find('option')
        .each((index, element) => {
          const optionElementValue = $(element).attr('value');
          if (!optionElementValue) {
            return;
          }
          possibleIds[fromLevel].push(optionElementValue);
        });
    }
    for (let level = fromLevel + 1; level <= levelsLength; level += 1) {
      if (typeof possibleIds[level - 1] === 'undefined') {
        break;
      }
      const subcategoriesForParentsNeeded = possibleIds[level - 1];
      let match = false;
      $.each(subcategoriesForParentsNeeded, (index, parentId) => {
        if (Object.keys(levels[level].categories).indexOf(parentId) > -1) {
          match = true;

          return false;
        }

        return true;
      });
      if (!match) {
        hideFrom = level;
        break;
      }
    }
    if (hideFrom !== false) {
      for (let level = hideFrom; level <= levelsLength; level += 1) {
        levels[level].$element.closest('.form-group').hide();
      }
    }
  }

  /**
   * Invalidation callback. Hides widget and logs warning.
   */
  function invalidate() {
    debugConsole.warn('Invalid dropDownNavigation widget. Hiding container.');
    $container.hide();
  }

  /**
   * Updates CTA button. Enables with given category data
   * or disables if category is not provided.
   * @param {Object|undefined} category category object
   */
  function updateCTA(category) {
    if (!category) {
      $CTAButton
        .addClass('disabled')
        .attr('href', '');

      return;
    }

    let href = `/${category.category_url}`;
    let cmds = null;
    if (window.sgData.device.access === 'Web') {
      if (window.location.pathname.indexOf('php/shopgate') === 1) {
        href = `/php/shopgate/${category.category_url}`;
      }
      href = new SGLink(href).toString();
    } else {
      href = new SGLink(href).toSgApiLink().toString();
      cmds = new SGLink(href).toCommands();
    }
    $CTAButton
      .removeClass('disabled')
      .attr('href', href)
      .data('sgcommands', '')
      .removeAttr('data-sgcommands');

    if (cmds) {
      $CTAButton
        .data('sgcommands', cmds)
        .attr('data-sgcommands', JSON.stringify(cmds));
    }
  }

  /**
   * Resets next levels to empty states starting from provided level+1;
   * @param {number} fromLevel starting level
   */
  function resetNextLevels(fromLevel) {
    for (let level = fromLevel; level <= levelsLength; level += 1) {
      levels[level].$element
        .attr('disabled', 'disabled')
        .find('option')
        .not('[value=""]')
        .remove()
        .end()
        .closest('.select-styling')
        .addClass('disabled')
        .closest('.form-group')
        .show();
    }
  }

  /**
   * Sort object properties (only own properties will be sorted).
   * @param {Object} obj object to sort properties
   * @param {boolean} reverse false - reverse sorting.
   * @returns {Array} array of items in [[Object],[Object],...] format.
   */
  function sortProperties(obj, reverse = false) {
    const reversed = (reverse) ? -1 : 1;

    const sortable = [];
    for (const key in obj) {
      if (obj[key].hasOwnProperty('order_index')) {
        sortable.push(obj[key]);
      }
    }

    sortable.sort((a, b) => {
      // Sort order_index desc
      const numericSort = reversed * (b.order_index - a.order_index);

      const x = a.name.toLowerCase();
      const y = b.name.toLowerCase();
      // Sort name asc
      const alphabeticSort = x < y ? reversed * -1 : x > y ? reversed : 0;

      // If numericSort = 0 -> doesn't matter, evaluate alphabeticSort
      // If numericSort < 0 -> lower index for order_index sort
      // If numericSort > 0 -> higher index order_index sort
      return numericSort || alphabeticSort;
    });

    return sortable;
  }

  /**
   * Updates selects starting from given level.
   * @param {number} level starting level
   * @param {Object} categoriesForLevel - array of categories for the level
   */
  function updateSelect(level, categoriesForLevel) {
    const options = [];
    const sortedCats = sortProperties(categoriesForLevel);

    if (sortedCats.length) {
      sortedCats.forEach((category) => {
        options.push($(`<option value="${category.id}">${category.name}</option>`));
      });
    } else {
      $.each(categoriesForLevel, (index, category) => {
        options.push($(`<option value="${category.id}">${category.name}</option>`));
      });
    }

    resetNextLevels(level);
    levels[level]
      .$element
      .append(options)
      .removeAttr('disabled')
      .closest('.select-styling')
      .removeClass('disabled');
  }

  /**
   * Select onchange callback
   * @param {HtmlElement} element changed element
   */
  function onChange(element) {
    const $this = $(element);
    const level = $this.data('level');
    const nextLevel = level + 1;
    const categoryId = $this.val() ? parseInt($this.val(), 10) : null;
    const isLastLevel = !levels.hasOwnProperty(nextLevel);
    if (categoryId) {
      const subCategories = isLastLevel ? {} : levels[nextLevel].categories[categoryId] || {};

      // no subcategory for this category
      if (!Object.keys(subCategories).length) {
        updateCTA(categoriesFlat[categoryId]);
        resetNextLevels(nextLevel);
        hideNonSelectable(level, categoryId);
        return;
      }
      updateSelect(nextLevel, subCategories);
      hideNonSelectable(nextLevel);
      updateCTA();
      return;
    }

    resetNextLevels(nextLevel);
    hideNonSelectable(level);
    updateCTA();
  }

  for (let i = 0; i < $selects.length; i += 1) {
    const level = i + 1;
    if (!categories.hasOwnProperty(level)) {
      return invalidate();
    }
    levels[level] = {
      $element: $($selects.get(i)),
      categories: categories[level],
    };
    $.each(categories[level], (index, cat) => {
      if (level === 1) {
        categoriesFlat[cat.id] = cat;
        return true;
      }
      $.each(cat, (indexButInsideEach, subcat) => {
        categoriesFlat[subcat.id] = subcat;
      });

      return true;
    });
    levelsLength += 1;
  }

  /* validating data */
  if (
    $container.length !== 1
    || !categories
    || Object.keys(categories[1]).length === 0
    || !$selects.length
  ) {
    return invalidate();
  }

  /* business logic */
  $selects.addClass('needsclick');
  $selects.on('change', function () {
    onChange(this);
  });

  // change first select for browser autocomplete purposes
  $selects.first().change();

  return $container;
}

export default dropDownNavigationInit;



// WEBPACK FOOTER //
// ./Library/1.0/common/widgets/dropdown-navigation-widget.js